import Http from "../http";

class BidServices {


 
      static async getAllBidsForCabRequest(id){
        return Http.get(`/cabrequestBids/${id}`)
      }
    
}
export default BidServices;